{
  "id": "leto",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Leto",
    "en": "Leto"
  },
  "icon": "gods/leto",
  "portrait": "gods/leto-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "automaton": 1
  },
  "unlocks": ["automaton", "hephaestus-revenge", "volcanic-forge", "perception"],
  "powers": ["spider-lair"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml ClassicalAgeLeto)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 automaton at the Temple (Kronos: +1 from KronosExtra*, so 2). God power SpiderLair (cooldown 60 s)."
  }
}
